<style lang="less" scoped>
    .modal-contain {
        /deep/ .ivu-modal-body {
            min-height: 0
        }
    }
</style>
<template>
  <div>
    <Modal
      v-model="modalDis"
      class="modal-contain"
      :closable="false"
      :mask-closable="false"
      title="修改状态"
    >
      <Form
        ref="form"
        :model="formData"
        :label-width="100"
      >
        <p v-if="modalType===2">
          是否需要{{ formData.has_frozen?'冻结':'解冻' }}
        </p>
        <FormItem 
          v-if="modalType===1"
          prop="has_frozen"
          label="状态"
        >
          <p v-show="formData.has_frozen===false">
            解冻
          </p>
          <p v-show="formData.has_frozen===true">
            冻结
          </p>
        </FormItem>
        <FormItem 
          v-if="modalType===1"
          prop="reason"
          label="操作原因"
          :rules="{ required: true, message: '操作原因必填', trigger: 'blur'}"
        >
          <Input
            v-model="formData.reason"
            type="textarea"
            placeholder="请输入操作原因"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="saveLoading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    props: {
      formProps: {
        type:Object,
        default:() => ({})
      },
      saveLoading:{
        type:Boolean,
        default:() => false
      },
      modalType: {
        type:Number,
        default:() => 1
      }
    },
    data() {
      return {
        formData: {
          reason:null,
          has_frozen: null
        },
        showModal: false
      }
    },
    computed: {
      modalDis() {
        return !!this.formProps
      }
    },
    watch: {
      formProps(value) {
        if (value) {
          this.formData.has_frozen = !value.has_frozen
        } else {
          this.$refs.form.resetFields()
          this.formData = {
            reason:null,
            has_frozen: null
          }
        }
      }
    },
    methods: {
      ok() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$emit('ok', { 
              reason: this.formData.reason,
              id: this.formProps.id,
              call:() => {
                this.$Message.success({
                  duration:0.7,
                  content:this.formData.has_frozen ? '冻结成功！' : '解冻成功'
                })
                this.cancel()
              }
            }) 
          }
        })
      },
      cancel() {
        this.$emit('cancel')
      },
    }
  }
</script>
